import { ScheduleCalendarStore } from "@lib/store/src/scheduleCalendar";
import { UiFloatModal } from "../../../common/modal";
import { ScheduleForm, ScheduleFormSubmitEvent } from "../../components/scheduleForm/scheduleForm";
import { mapFormValuesToScheduleItem } from "../../components/scheduleForm/scheduleForm.helper";
import { ScheduleItem } from "@lib/types";
import { getTemporaryScheduleItemId } from "../../utils/getTemporaryScheduleItemId";

// Side effect import to define custom element.
// eslint-disable-next-line no-duplicate-imports
import "../../components/scheduleForm/scheduleForm";

type AddScheduleModalParams = Readonly<{
    initialDate?: Date;
}>;

/** Add schedule modal. */
export class AddScheduleModal {

    /** Popup instance. */
    public readonly popup: UiFloatModal;

    private readonly form: ScheduleForm;

    private readonly store: ScheduleCalendarStore;

    public constructor(store: ScheduleCalendarStore, onSave: (scheduleItem: ScheduleItem) => void) {
        this.store = store;
        try {
            this.popup = new UiFloatModal(
                "<schedule-form class=\"form full-height\"></schedule-form>",
                true,
                { bottom: true, right: true, left: true },
                { width: 578, height: 300 },
            );
            this.popup.modalComponent.x = 10;
            this.popup.modalComponent.y = 10;
            this.popup.modalComponent.minWidth = 578;

            const form = this.popup.modalComponent.querySelector<ScheduleForm>(".form");

            if (form === null) {
                throw new Error("Could not find schedule form element.");
            }

            this.form = form;

            this.popup.modalComponent.onClose = () => {
                this.form.closeChildModals();
            };

            this.form.addEventListener("scheduleFormSubmit", (event: ScheduleFormSubmitEvent) => {
                const scheduleItem = mapFormValuesToScheduleItem(event.detail.values, getTemporaryScheduleItemId());
                onSave(scheduleItem);
                this.form.closeChildModals();
                this.close();
            });
            this.form.addEventListener("scheduleFormCancel", () => {
                this.form.closeChildModals();
                this.handleFormCancel();
            });

        } catch(e) {
            console.error("Error <initPopup> >> ", e);
        }
    }

    /**
     * Opens modal.
     * @param params Open parameters.
     */
    public open(params?: AddScheduleModalParams): void {
        this.popup.modalComponent.open();

        this.form.resetForm();
        this.form.initialName = this.getEventInitialName();
        this.form.initialDate = params?.initialDate ?? null;
        this.popup.uiModal.resetSize();
    }

    /** Closes modal. */
    public close(): void {
        this.popup.modalComponent.close();
    }

    private handleFormCancel(): void {
        this.close();
    }

    private getEventInitialName(): string {
        let number = 1;

        const scheduleNames = this.store.schedules.map(schedule => schedule.name);
        while (scheduleNames.includes(`Событие №${number}`)) {
            number++;
        }
        return `Событие №${number}`;
    }
}
